import ValidatorHandler from "./ValidatorHandler.js";
import {
  showModalSuccess,
  showCodeSuccess,
  showSuccessMessage,
} from "../js/modal.js";

const formValidator = new ValidatorHandler();
const forms = document.querySelectorAll(".form");

if (forms.length) {
  forms.forEach(form => {
    form.addEventListener("submit", async event => {
      event.preventDefault();
      const form = event.target,
        action = form.getAttribute("action") || "ems_sklad_form_handler";

      if (formValidator.validateForm(form)) {
        const fd = new FormData(form),
          requiredFields = [],
          dataRequiredFields = form.querySelectorAll("[data-require]");

        if (fd.has("phone")) {
          const phoneField = fd.get("phone"),
            phoneCode =
              form.querySelector(".iti__selected-dial-code").textContent || "";
          fd.set("phone", `${phoneCode} ${phoneField}`);
        }

        if (dataRequiredFields) {
          dataRequiredFields.forEach(item => {
            if ("name" in item) {
              requiredFields.push(item.name);
            }
          });
        }

        fd.append("required_fields", requiredFields);
        // отправляем на сервер

        await fetch(VARS.ajax_url.toString().replace("%%endpoint%%", action), {
          method: "POST",
          body: fd,
        })
          .then(r => r.json())
          .then(response => {
            if (false === response.success) {
              // TODO: Обработка ошибок
              const {
                name,
                phone,
                email,
                email_or_phone,
                company_name,
                personal,
                password,
              } = response.data;

              handleServerErrors(
                {
                  name,
                  phone,
                  email,
                  email_or_phone,
                  company_name,
                  personal,
                  password,
                },
                form
              );

              throw new Error(JSON.stringify(response.data));
            } else {
              if (response?.data?.redirect) {
                window.location.href = response.data.redirect;
              } else {
                // проверяем id формы и отображаем соответствующее модальное окно
                if (form.id === "form-connect" || form.id === "form-send") {
                  showModalSuccess();
                } else if (form.id === "form-restore") {
                  showCodeSuccess();
                } else if (form.id === "form-сonsultation") {
                  showSuccessMessage();
                }

                const modal = form.closest(".modal");

                form.reset();
                modal && modal.classList.remove("active");
              }
            }
          })
          .catch(errors => {
            console.log(errors);
          });
      }
    });

    const inputs = form.querySelectorAll("input");

    if (inputs.length) {
      inputs.forEach(i => {
        ["input", "blur", "change"].forEach(eventHandler => {
          i.addEventListener(eventHandler, () => {
            formValidator.validateInput(i);
          });
        });
      });
    }
  });
}

// Обрабатываем ошибки серверной валидации и добавлеяем красный бордер инпутам
function handleServerErrors(errors, form) {
  const inputs = form.querySelectorAll("input");
  inputs.forEach(input => {
    input.classList.remove("input-error");
  });

  const errorMessages = form.querySelectorAll(".error");
  errorMessages.forEach(error => {
    error.textContent = "";
  });

  for (const key in errors) {
    if (errors[key]) {
      const input = form.querySelector(`[name="${key}"]`);
      if (input) {
        input.classList.add("input-error");

        const errorElement = form.querySelector(`.${key}-error`);
        if (errorElement) {
          errorElement.textContent = errors[key];
          errorElement.style.display = "block";
        }
      }
    }
  }
}
